<template>
  <div class="container">
    <div class="title">作业管理情况</div>
    <div class="header_num">
      <div class="header-item">
        <div class="header-item-smallTitle">
          <span>学校作业公示情况</span>
        </div>
        <div class="header-item-box">
          <div class="box-right">
            <div>
              <p class="box-blue">{{ 2 }}</p>
              <p class="w_100">参与备案学校总数</p>
            </div>
            <div>
              <p class="box-blue mr">
                {{ 1 }}%
              </p>
              <p>参与率</p>
            </div>
          </div>
        </div>
      </div>
      <div class="header-item">
        <div class="header-item-smallTitle">
          <span>学校作业反馈情况</span>
        </div>
        <div class="header-item-box">
          <div class="box-right">
            <div>
              <p class="box-blue">{{ 3 }}</p>
              <p>
                被反馈学校总数
              </p>
            </div>
            <div>
              <p class="box-blue mr">
                {{ 4 }}%
              </p>
              <p>参与率</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {},
};
</script>
<style lang="less" scoped >
.title {
  text-align: center;
  border-bottom: 1px solid #d7d7d7;
  padding: 10px 0;
  margin-bottom: 20px;
}
.header_num {
    border: 1px solid #d7d7d7;
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
  .header-item {
    width: calc(50% - 50px);
    border: 1px solid #eee;
    background-color: #fcfcfc;
    text-align: center;
    padding: 20px;
    .bigTitle {
      font-weight: bold;
      color: #fff;
    }
    .cont {
      font-size: 18px;
      color: #fff;
    }
    .header-item-smallTitle {
      display: flex;
      align-items: center;
      font-size: 18px;
      height: 22px;
      color: #333;
          img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
    .header-item-box {
      margin-top: 30px;
      .box-right {
        display: flex;
        justify-content: center;
        .mr {
          margin-right: 60px;
        }
        div{
            width: 100%;
        }
        p {
          width: 100%;
          font-size: 14px;
          text-align: center;
          color: #999;
        }
        .box-blue {
          font-weight: bold;
          margin-bottom: 5px;
          font-size: 20px;
          color: #4794e8;
        }
      }
    }
  }
}
</style>
